module.exports = __webpack_public_path__ + "img/follow_2.73241c30.png";